import { addPersonalCategory, removePersonalCategory } from '../../Filters/actions/filtersActions';
import { fetchProducts } from '../../Listing/actions/listingActions';
import { SELECT_SORT_ORDER } from './actionTypes';

export const selectSortOrder = order => (dispatch) => {
    dispatch({
        type: SELECT_SORT_ORDER,
        payload: order
    });

    if (order === 'personalcategory') {
        dispatch(addPersonalCategory());
    } else {
        dispatch(removePersonalCategory());
    }

    dispatch(fetchProducts());
};
